import { toggleDrawer } from '@root/app/shared/stores/sidebarStore';

/** Toggles the navigation drawer (desktop collapse / mobile overlay). */
export const toggleMiniNavbar = (): void => {
    toggleDrawer();
};
